import { Outlet } from "react-router-dom";
import Loading from "../../components/Loading";

const LayoutEmpty = () => {
    return (
        <div className="App">
            <Outlet />
            <Loading />
        </div>
    );
}

export default LayoutEmpty;